import { Fragment } from 'react';
import settings from '@/settings';
import { getOptions } from './constants';

const categoryCount = getOptions()?.[settings.store]?.length ?? 0;

// Rendered height of MarketplaceV2, measured per breakpoint
const MarketplacePlaceholder = () => (
  <div className="min-h-[479px] xs:min-h-[513px] sm:min-h-[537px] md:min-h-[361px]" />
);

// Mirrors the layout of BusinessCategories (one 365px carousel per category,
// with MarketplaceV2 after the second) while its chunk loads.
const BusinessCategoriesPlaceholder = () => {
  if (!categoryCount) {
    return <MarketplacePlaceholder />;
  }

  return (
    <>
      {Array.from({ length: categoryCount }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <div className="h-[365px] bg-white" />
          {index === 1 && <MarketplacePlaceholder />}
        </Fragment>
      ))}
    </>
  );
};

export default BusinessCategoriesPlaceholder;
